// extracted by mini-css-extract-plugin
export default {"rating":"DH-z","numberOfStars":"EH-z","count":"FH-z","barGraphSpacing":"GH-z","barGraph":"HH-z"};